export default "__VITE_ASSET__BbLu3tek__"